import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, objectToQueryParameters, processError } from "../../../core/helpers/service-helper";

export const crearOEditarSede = async (sede) => {
    try {
        const resp = await axios.post(`${API_URL}/sedes`, sede, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

/**
 *
 * @returns {Promise<object[]>}
 */
export const selectSedes = async (params = {}) => {
    const queries = objectToQueryParameters(params);

    try {
        const resp = await axios.get(`${API_URL}/sedes?${queries}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

/**
 *
 * @returns {Promise<object[]>}
 */
export const obtenerSedePorId = async (id) => {
    try {
        const resp = await axios.get(`${API_URL}/sedes/${id}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

/**
 *
 * @returns {Promise<object[]>}
 */
export const obtenerDatosCreacionSede = async (id = null) => {
    try {
        const data = {};
        id && (data.sedeId = id);

        const resp = await axios.post(
            `${API_URL}/sedes/obtenerDatosCreacion`,
            data,
            {
                headers: getHeaders(),
            }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const selectSedePorCiudad = async (ciudadId) => {
    try {
        const resp = await axios.get(`${API_URL}/sedes?ciudadId=${ciudadId}`, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const cambiarEstadoSede = async (idSede, estado) => {
    try {
        const resp = await axios.post(
            `${API_URL}/sedes/cambiarEstado/${idSede}`,
            { estado },
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
